var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stream-components-popover",class:{'stream-components-popover--triggered': _vm.triggered},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')},"mouseenter":function($event){return _vm.$emit('mouseenter')},"mouseleave":function($event){return _vm.$emit('mouseleave')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }